


// import React, { useState, useEffect } from "react";
// import { Layout, Menu, Card, Button, Drawer } from "antd";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom"; // ← ADD THIS
// import { API_BASE_URL } from "../../Config";
// import "./DictionaryPage.css";
// import AdvertisementCard from "../AdvertisementCard";

// const { Sider, Content } = Layout;

// const DictionaryPage = () => {
//   const { langSlug } = useParams(); // ← reads /dictionary/:langSlug
//   const navigate = useNavigate();

//   const [selectedLanguage, setSelectedLanguage] = useState(null);
//   const [selectedSection, setSelectedSection] = useState("category");
//   const [allYogaPages, setAllYogaPages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeKey, setActiveKey] = useState(null);
//   const [mobile, setMobile] = useState(false);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [openKeys, setOpenKeys] = useState([]);

//   useEffect(() => {
//     const resize = () => setMobile(window.innerWidth < 900);
//     resize();
//     window.addEventListener("resize", resize);
//     return () => window.removeEventListener("resize", resize);
//   }, []);

//   useEffect(() => {
//     const fetchAllYoga = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/allpages?page=dictionary`);
//         const data = res.data?.data || [];
//         setAllYogaPages(data);

//         if (data.length > 0) {
//           // Match URL slug like "tamil", "english", "spanish"
//           const matchedLang = langSlug
//             ? data.find(
//                 (l) =>
//                   l.yogaType.toLowerCase().replace(/\s+/g, "-") === langSlug
//               )
//             : null;

//           const defaultLang = matchedLang || data[0];
//           setSelectedLanguage(defaultLang);
//           setSelectedSection("alphabet");
//           setActiveKey(`${defaultLang._id}-alphabet`);
//           setOpenKeys([defaultLang._id]);

//           // If no slug in URL, redirect to first language
//           if (!langSlug) {
//             navigate(
//               `/dictionary/${defaultLang.yogaType
//                 .toLowerCase()
//                 .replace(/\s+/g, "-")}`,
//               { replace: true }
//             );
//           }
//         }
//       } catch (error) {
//         console.error("API Fetch Error", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllYoga();
//   }, [langSlug, navigate]); // re-runs when URL changes

//   const getSelectedContent = () => {
//     if (!selectedLanguage) return "<p>Please select a category from the left.</p>";
//     return selectedSection === "category"
//       ? selectedLanguage.categoryContent
//       : selectedLanguage.alphabetContent;
//   };

//   const handleSelect = (lang, section) => {
//     setSelectedLanguage(lang);
//     setSelectedSection(section);
//     setActiveKey(`${lang._id}-${section}`);
//     setOpenKeys([lang._id]);
//     // ← Clean URL navigation
//     navigate(
//       `/dictionary/${lang.yogaType.toLowerCase().replace(/\s+/g, "-")}`
//     );
//   };

//   const menuItems = allYogaPages.map((lang) => ({
//     key: lang._id,
//     label: lang.yogaType,
//    children: [
//   {
//     key: `${lang._id}-alphabet`,
//     label: "Alphabet",
//     onClick: () => handleSelect(lang, "alphabet"),
//   },
//   {
//     key: `${lang._id}-category`,
//     label: "Category",
//     onClick: () => handleSelect(lang, "category"),
//   },
// ],
//   }));

//   // Keys for all top-level language submenus
//   const rootSubmenuKeys = allYogaPages.map((lang) => lang._id);

//   // Accordion logic: only one root submenu open at a time
//   const onOpenChange = (keys) => {
//     const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
//     if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
//       setOpenKeys(keys);
//     } else {
//       setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
//     }
//   };



//   // Mobile layout
//   if (mobile) {
//     return (
//       <>
//         <div style={{ padding: "90px 16px 16px" }}>
//           <Button
//             style={{
//               background: "#1f2937",
//               color: "#fff",
//               borderRadius: "8px",
//               marginBottom: "16px",
//             }}
//             onClick={() => setDrawerOpen(true)}
//           >
//             ☰ Languages
//           </Button>

//           {loading ? (
//             <h2>Loading...</h2>
//           ) : (
//             <Card style={{ borderRadius: "12px", padding: "16px" }}>
//               <div
//                 className={`page-content ${
//                   selectedSection === "alphabet" ? "alphabet-view" : ""
//                 }`}
//                 dangerouslySetInnerHTML={{ __html: getSelectedContent() }}
//               />
//             </Card>
//           )}
//         </div>

//         <Drawer
//           title="Languages"
//           placement="left"
//           open={drawerOpen}
//           onClose={() => setDrawerOpen(false)}
//           width={260}
//           bodyStyle={{ padding: 0 }}
//         >
//           <Menu
//             mode="inline"
//             selectedKeys={activeKey ? [activeKey] : []}
//             openKeys={openKeys}
//             onOpenChange={onOpenChange}
//             items={menuItems.map((lang) => ({
//               key: lang.key,
//               label: lang.label,
//               children: lang.children.map((child) => ({
//                 key: child.key,
//                 label: child.label,
//                 onClick: () => {
//                   child.onClick();
//                   setDrawerOpen(false);
//                 },
//               })),
//             }))}
//           />
//         </Drawer>
//       </>
//     );
//   }

//   // Desktop layout
//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         padding: "30px 10px",
//         minHeight: "100vh",
//         background: "#f0f2f5",
//       }}
//     >
//       <Layout
//         style={{
//           width: "90%",
//           maxWidth: "1200px",
//           background: "#fff",
//           borderRadius: "16px",
//           boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//           display: "flex",
//           overflow: "hidden",
//         }}
//       >
//         <Sider width={250} style={{ height: "900px", position: "relative" }}>
//           <div style={{ position: "absolute", inset: 0 }} />

//           <div
//             style={{
//               position: "relative",
//               zIndex: 2,
//               padding: "16px",
//               fontWeight: "bold",
//               textAlign: "center",
//               color: "#fff",
//             }}
//           >
//             Languages
//           </div>

//          <Menu
//   mode="inline"
//   className="dictionary-menu"
//   selectedKeys={activeKey ? [activeKey] : []}
//   openKeys={openKeys}
//   onOpenChange={onOpenChange}
//   items={menuItems}
// />
//         </Sider>

//         <Content style={{ padding: "30px" }}>
//           {loading ? (
//             <h2>Loading...</h2>
//           ) : (
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={selectedLanguage?.yogaType}
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -20 }}
//                 transition={{ duration: 0.4 }}
//               >
//                 <Card style={{ borderRadius: "12px", padding: "24px" }}>
//                   <div
//                     className={`page-content ${
//                       selectedSection === "alphabet" ? "alphabet-view" : ""
//                     }`}
//                     dangerouslySetInnerHTML={{ __html: getSelectedContent() }}
//                   />
//                 </Card>
//               </motion.div>
//             </AnimatePresence>
//           )}
//         </Content>
//       </Layout>

//       <AdvertisementCard />
//     </motion.div>
//   );
// };

// export default DictionaryPage;

import React, { useState, useEffect, useMemo } from "react";
import { Layout, Menu, Card, Button, Drawer, Input, Pagination } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../Config";
import "./DictionaryPage.css";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

export const splitHtmlIntoSections = (html) => {
  if (!html) return [];
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  const sections = [];
  let current = null;

  Array.from(wrapper.children).forEach((node) => {
    const isHeading = /^H[1-6]$/.test(node.tagName);
    if (isHeading || !current) {
      current = { heading: node.outerHTML, body: [] };
      sections.push(current);
      if (isHeading) return;
    }
    current.body.push(node.outerHTML);
  });

  return sections.map((s) => s.heading + s.body.join(""));
};

const DictionaryPage = () => {
  const { langSlug } = useParams();
  const navigate = useNavigate();

  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedSection, setSelectedSection] = useState("category");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true); // initial language list load
  const [activeKey, setActiveKey] = useState(null);
  const [mobile, setMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const SECTIONS_PER_PAGE = 3;

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 900);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // Fetch the language/section list (sidebar)
  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=dictionary`);
        const data = res.data?.data || [];
        setAllYogaPages(data);

        if (data.length > 0) {
          const matchedLang = langSlug
            ? data.find(
                (l) => l.yogaType.toLowerCase().replace(/\s+/g, "-") === langSlug
              )
            : null;

          const defaultLang = matchedLang || data[0];
          setSelectedLanguage(defaultLang);
          setSelectedSection("alphabet");
          setActiveKey(`${defaultLang._id}-alphabet`);
          setOpenKeys([defaultLang._id]);

          if (!langSlug) {
            navigate(
              `/dictionary/${defaultLang.yogaType.toLowerCase().replace(/\s+/g, "-")}`,
              { replace: true }
            );
          }
        }
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, [langSlug, navigate]);

  const getSelectedContent = () => {
    if (!selectedLanguage)
      return "<p>Please select a category from the left.</p>";
    return selectedSection === "category"
      ? selectedLanguage.categoryContent
      : selectedLanguage.alphabetContent;
  };

  const selectedContent = getSelectedContent();

  const sections = useMemo(
    () => splitHtmlIntoSections(selectedContent),
    [selectedContent]
  );

  const pagedHtml = useMemo(() => {
    const start = (currentPage - 1) * SECTIONS_PER_PAGE;
    return sections.slice(start, start + SECTIONS_PER_PAGE).join("");
  }, [sections, currentPage]);

  // Reset to page 1 whenever language/section changes.
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLanguage, selectedSection]);

  const handleSelect = (lang, section) => {
    setSelectedLanguage(lang);
    setSelectedSection(section);
    setActiveKey(`${lang._id}-${section}`);
    setOpenKeys([lang._id]);
    navigate(`/dictionary/${lang.yogaType.toLowerCase().replace(/\s+/g, "-")}`);
  };

  const filteredLangPages = allYogaPages.filter((lang) =>
    lang.yogaType.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedLangPages = [...filteredLangPages].sort((a, b) =>
    a.yogaType.localeCompare(b.yogaType)
  );

  const menuItems = sortedLangPages.map((lang) => ({
    key: lang._id,
    label: lang.yogaType,
    children: [
      {
        key: `${lang._id}-alphabet`,
        label: "Alphabet",
        onClick: () => handleSelect(lang, "alphabet"),
      },
      {
        key: `${lang._id}-category`,
        label: "Category",
        onClick: () => handleSelect(lang, "category"),
      },
    ],
  }));

  const rootSubmenuKeys = allYogaPages.map((lang) => lang._id);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const languageSearch = (
    <div style={{ padding: "0 16px 12px" }}>
      <Input
        placeholder="Search language..."
        prefix={<SearchOutlined style={{ color: "#9fb3c8" }} />}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ borderRadius: "8px" }}
      />
    </div>
  );

  const renderContent = () => (
    <>
      <Card style={{ borderRadius: "12px", padding: "24px" }}>
        <div
          className={`page-content ${
            selectedSection === "alphabet" ? "alphabet-view" : ""
          }`}
          dangerouslySetInnerHTML={{ __html: pagedHtml }}
        />
      </Card>

      {sections.length > SECTIONS_PER_PAGE && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
          <Pagination
            current={currentPage}
            total={sections.length}
            pageSize={SECTIONS_PER_PAGE}
            simple={mobile}
            onChange={(page) => {
              setCurrentPage(page);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            showSizeChanger={false}
          />
        </div>
      )}
    </>
  );

  // Mobile layout
  if (mobile) {
    return (
      <>
        <div style={{ padding: "90px 16px 16px" }}>
          <Button
            style={{
              background: "#1f2937",
              color: "#fff",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
            onClick={() => setDrawerOpen(true)}
          >
            ☰ Languages
          </Button>

          {loading ? <h2>Loading...</h2> : renderContent()}
        </div>

        <Drawer
          title="Languages"
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={260}
          bodyStyle={{ padding: 0 }}
        >
          {languageSearch}

          <div
            className="dictionary-menu-scroll"
            style={{ maxHeight: "calc(100vh - 130px)", overflowY: "auto" }}
          >
            <Menu
              mode="inline"
              selectedKeys={activeKey ? [activeKey] : []}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              items={menuItems.map((lang) => ({
                key: lang.key,
                label: lang.label,
                children: lang.children.map((child) => ({
                  key: child.key,
                  label: child.label,
                  onClick: () => {
                    child.onClick();
                    setDrawerOpen(false);
                  },
                })),
              }))}
            />
          </div>
        </Drawer>
      </>
    );
  }

  // Desktop layout
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider width={250} style={{ position: "relative" }}>
          <div style={{ position: "absolute", inset: 0 }} />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Languages
          </div>

          {languageSearch}

         <div className="dictionary-menu-scroll" style={{ maxHeight: "calc(100vh - 220px)", overflowY: "auto" }}>
            <Menu
              mode="inline"
              className="dictionary-menu"
              selectedKeys={activeKey ? [activeKey] : []}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              items={menuItems}
            />
          </div>
        </Sider>

        <Content style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={`${selectedLanguage?.yogaType}-${selectedSection}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                {renderContent()}
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>

      <AdvertisementCard />
    </motion.div>
  );
};

export default DictionaryPage;
